import { defineStore } from 'pinia';
import { ref, computed, watch } from 'vue';
import {useDataStore} from "@/stores/dataStore.js";

export const useCartStore = defineStore('cart', () => {
    // Cart state
    const isOpen = ref(false);
    const items = ref([]);

    // Load cart data from localStorage on initialization
    const initializeCart = () => {
        const savedCart = localStorage.getItem('eskragCart');
        if (savedCart) {
            try {
                items.value = JSON.parse(savedCart);
            } catch (e) {
                console.error('Failed to parse saved cart:', e);
                items.value = [];
            }
        }
    };

    // Call initialize immediately
    initializeCart();

    // Watch for cart changes and save to localStorage
    watch(
        items,
        (newItems) => {
            localStorage.setItem('eskragCart', JSON.stringify(newItems));

        },
        { deep: true }
    );

    // Computed properties
    const count = computed(() => {
        return items.value.reduce((total, item) => total + item.quantity, 0);
    });

    const total = computed(() => {
        const sum = items.value.reduce((total, item) => {
            return total + (item.price * item.quantity);
        }, 0);
        return sum;
    });

    const isEmpty = computed(() => items.value.length === 0);

    // Methods
    const toggleCart = () => {
        isOpen.value = !isOpen.value;
        console.log('Cart toggled:', isOpen.value);
    };

    const addItem = (product) => {
        // Check if product already exists in cart
        const existingItem = items.value.find(item => item.id === product.id);

        if (existingItem) {
            // If it's the same product with the same custom fields, increase quantity
            if (
                (existingItem.playerInfo === product.playerInfo || (!existingItem.playerInfo && !product.playerInfo)) &&
                (existingItem.amount === product.amount || (!existingItem.amount && !product.amount)) &&
                (existingItem.amount2 === product.amount2 || (!existingItem.amount2 && !product.amount2))
            ) {
                existingItem.quantity += product.quantity;
            } else {
                // If it's the same product ID but with different custom fields, add as new item
                // Add a unique identifier to avoid collision
                const uniqueId = `${product.id}-${Date.now()}`;
                items.value.push({
                    ...product,
                    id: uniqueId
                });
            }
        } else {
            console.log('Adding new product to cart:', product);
            items.value.push(product);
        }
    };

    const updateQuantity = (id, newQuantity) => {
        const item = items.value.find(item => item.id === id);
        if (item) {
            item.quantity = Math.max(1, newQuantity);
        }
    };

    const removeItem = (id) => {
        items.value = items.value.filter(item => item.id !== id);
    };

    const clearCart = () => {
        items.value = [];
    };

    // Force save cart to localStorage
    const saveCart = () => {
        localStorage.setItem('eskragCart', JSON.stringify(items.value));
    };

    const recalculatePrices = () => {

        const datastore = useDataStore();

        function fetchUpdatedPrice(id) {
            return  datastore.articles.find(article => article.id.toString() === id.toString())?.prix;

        }

        items.value = items.value.map(item => {
            // Simulate fetching updated price from a product service
            const updatedPrice = fetchUpdatedPrice(item.id);
            return {
                ...item,
                price: updatedPrice
            };
        });


    };


    return {
        isOpen,
        items,
        count,
        total,
        isEmpty,
        toggleCart,
        addItem,
        updateQuantity,
        removeItem,
        clearCart,
        saveCart,
        recalculatePrices
    };
});